import { useState } from 'react';
import { TissueMagneticPropertiesSectionProps } from './tissue-magnetic-properties-section';
import { ExperimentConfiguration } from '../../../../models';

export type TissueMagneticPropertyMode = 'default' | 'advanced';

type UseTissueMagneticPropertiesModeProps = Pick<
  TissueMagneticPropertiesSectionProps,
  'setUseCustomTissueMagneticProperties'
> & {
  customTissueMagneticPropertiesConfiguration?: ExperimentConfiguration;
};

export const useTissueMagneticPropertiesMode = ({
  customTissueMagneticPropertiesConfiguration,
  setUseCustomTissueMagneticProperties,
}: UseTissueMagneticPropertiesModeProps): {
  tissueMagneticPropertyMode: TissueMagneticPropertyMode;
  onTissueMagneticPropertyModeChange: (newTissueMagneticPropertyMode: TissueMagneticPropertyMode) => void;
} => {
  const isUsingCustomTissueMagneticProperties = customTissueMagneticPropertiesConfiguration?.selectedValue === '1';
  const [tissueMagneticPropertyMode, setTissueMagneticPropertyMode] = useState<TissueMagneticPropertyMode>(
    isUsingCustomTissueMagneticProperties ? 'advanced' : 'default'
  );

  const onTissueMagneticPropertyModeChange = (newTissueMagneticPropertyMode: TissueMagneticPropertyMode) => {
    if (!customTissueMagneticPropertiesConfiguration?.id) return;

    setUseCustomTissueMagneticProperties(
      'true',
      newTissueMagneticPropertyMode === 'advanced' ? '1' : '0',
      customTissueMagneticPropertiesConfiguration.name
    );

    setTissueMagneticPropertyMode(newTissueMagneticPropertyMode);
  };

  return { tissueMagneticPropertyMode, onTissueMagneticPropertyModeChange };
};
